// Regex for validating Saudi (966) or Egypt (20) mobile numbers, starting with 05 or 01 and correct length
export const mobileValidation = /^((([0]{2}|[+])(966|20))|0)((5\d{8})|(1\d{9}))$/;

// Regex for validating email addresses (basic format: user@domain.tld with at least 3 chars in TLD)
export const emailValidation = /^[^\s@]+@[^\s@]+\.([^\s@]{3})+$/;

// Regex for validating passwords: at least 10 characters, must contain letters or digits
export const passwordValidation = /^(?=.*[A-Za-z]|\d)[A-Za-z\d]{10,}$/;